<template>
    <modal ref="modal">
        <div class="d-flex flex-column gap-6 mt-6">
            <p class="fs-4 fw-600 text-center">{{$trans('storefront::image_editor.save_draft')}}</p>

            <div class="d-flex gap-3">
                <input type="text" class="form-control no-bg-image" ref="input" v-model="store.title" :placeholder="$trans('storefront::image_editor.draft.title')" @input="clearErrors">
            </div>

            <div class="d-flex flex-column flex-sm-row gap-3 gap-sm-4 justify-content-end">
                <button type="button" class="btn btn-secondary btn-medium d-flex justify-content-center" @click="save" style="min-width: 120px">
                    <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status" style="border-width: 2px">
                        <span class="sr-only">Loading...</span>
                    </div>

                    <template v-else>
                        {{$trans('storefront::image_editor.save')}}
                    </template>
                </button>
                <button type="button" class="btn btn-primary btn-medium" data-dismiss="modal" style="min-width: 120px">{{$trans('storefront::image_editor.close')}}</button>
            </div>
        </div>
    </modal>
</template>

<script>
import {useDraftStore} from "./store";
import axios from 'axios';

export default {
    setup() {
        const store = useDraftStore();
        return {
            store,
            loading: false,
        };
    },
    methods: {
        open() {
            this.$refs['modal'].openModal();
        },
        clearErrors() {
            $(this.$refs.input).removeClass('is-invalid');
        },
        save() {
            let app = this;

            if (!app.store.title) {
                $(app.$refs.input).addClass('shake-animation');
                $(app.$refs.input).addClass('is-invalid');

                setTimeout(function() {
                    $(app.$refs.input).removeClass('shake-animation');
                }, 300);

                return;
            }

            this.sendSaveRequest();
        },
        sendSaveRequest () {
            let app = this;
            app.loading = true;

            let imageEditor = window.imageEditor;
            imageEditor.save({callback: onSaveComplete});

            function onSaveComplete(data) {
                delete data.image;

                let formData = {
                    title: app.store.title,
                    data: data,
                };

                axios.post('/image-editor/drafts/store', formData).then(function (response) {
                    $swal.fire($trans('storefront::image_editor.draft.save_success.title'), $trans('storefront::image_editor.draft.save_success.description'),'success')
                }).catch(function (error) {
                    $swal.fire($trans('storefront::image_editor.error'), error.response.data.error ?? error.message ?? $trans('storefront.image_editor.error_general'),'error');
                    console.log(error);
                }).finally(()=> {
                    app.loading = false;
                    app.$refs.modal.closeModal();
                });
            }
        }
    }
}
</script>
